import BaseClient from './BaseClient';

class AuthService extends BaseClient {
    register(params) {
        const url = `/register`;
        return this.makeCoreApiRequest(url, 'post', params);
    }
}

export default new AuthService();
